import axios from 'axios'
import { isCancelledRequest, normalizeAxiosApiError } from './normalizeAxiosApiError.js'

export function normalizeApiError(error, options = {}) {
  const fallback = options.fallbackMessage ?? 'Something went wrong. Please try again.'

  if (isCancelledRequest(error)) {
    return { message: 'Request cancelled', code: 'cancelled', retryable: false, cause: error }
  }

  if (axios.isAxiosError(error)) return normalizeAxiosApiError(error, fallback)

  if (error instanceof Error) {
    return { message: error.message || fallback, code: 'unknown_error', retryable: false, cause: error }
  }

  return { message: fallback, code: 'unknown_error', retryable: false, cause: error }
}
